var _rect, _rect2, _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVesselImageDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 190,
    viewBox: "0 0 430 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 58,
    width: 430,
    height: 132,
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 63,
    fill: "#E2EEF9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    x: 0,
    y: 0,
    width: 430,
    height: 190
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 190,
    fill: "#DBE1E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.833 -7.47411C299.093 -22.5247 310.801 -29.9238 310.801 -29.9238L576.57 -39.7063C576.57 -39.7063 592.654 -29.0098 562.968 -21.0428C554.899 -12.0068 508.883 -9.69046 508.883 -9.69046L476.231 -24.2334C476.231 -24.2334 476.231 5.28286 440.03 2.40885C419 15.015 377.861 7.28286 377.861 7.28286C377.861 7.28286 368.999 20.4992 343.55 15.015C307.999 28.9992 267.991 -1.16242 285.833 -7.47411Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96 61.4999L357.5 60.9999C357.5 60.9999 317 42.4999 295.5 46.9999C274 51.4999 251 24.9999 218.5 41.4999C213.5 31.9999 169.5 21.9999 149 32.4999C128.5 42.9999 72 10.4999 51 -1.00009H-96V61.4999Z",
    fill: "#DDE1E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 148,
    width: 159,
    height: 8,
    rx: 4,
    fill: "#D1DAE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -72,
    y: 74,
    width: 159,
    height: 6,
    rx: 3,
    fill: "#E0E6EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -129,
    y: 86,
    width: 159,
    height: 6,
    rx: 3,
    fill: "#E0E6EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 136,
    width: 159,
    height: 6,
    rx: 3,
    fill: "#E0E6EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 78,
    width: 45,
    height: 6,
    rx: 3,
    fill: "#E0E6EB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165 143.847C165 145.002 165.958 145.959 167.113 145.959H175.564C176.719 145.959 177.676 145.002 177.676 143.847C177.676 142.692 176.719 141.734 175.564 141.734H167.113C165.958 141.734 165 142.692 165 143.847Z",
    fill: "#D1DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265 143.847C265 142.692 264.043 141.734 262.888 141.734H254.437C253.282 141.734 252.324 142.692 252.324 143.847C252.324 145.002 253.282 145.959 254.437 145.959H262.888C264.043 145.959 265 145.002 265 143.847Z",
    fill: "#D1DAE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.55 149.48C256.55 148.325 255.592 147.368 254.437 147.368H172.746C171.591 147.368 170.633 148.325 170.633 149.48C170.633 150.635 171.591 151.593 172.746 151.593H254.437C255.592 151.593 256.55 150.635 256.55 149.48Z",
    fill: "#D1DAE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.015 153.001C182.86 153.001 181.902 153.959 181.902 155.114C181.902 156.269 182.86 157.227 184.015 157.227H245.988C247.143 157.227 248.101 156.269 248.101 155.114C248.101 153.959 247.143 153.001 245.988 153.001H184.015Z",
    fill: "#D1DAE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.211 53.7042V65.6763H229.789V53.7042C229.789 53.3099 229.479 53 229.085 53H200.915C200.521 53 200.211 53.3099 200.211 53.7042Z",
    fill: "#A6A6A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.829 141.734H212.886V112.86C212.886 111.705 213.844 110.747 214.999 110.747C216.153 110.747 217.111 111.705 217.111 112.86V141.734H247.168L257.563 102.719L214.999 81.4226L172.406 102.719L182.829 141.734Z",
    fill: "#A6A6A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.492 70.606V93.9586L214.042 77.1695C214.634 76.8597 215.338 76.8878 215.929 77.1695L249.479 93.9586V70.606C249.479 70.2117 249.169 69.9018 248.775 69.9018H181.196C180.802 69.9018 180.492 70.2117 180.492 70.606Z",
    fill: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 215,
    y1: 58,
    x2: 215,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0412371,
    stopColor: "#E0E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94A8B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselImageDefault);
export default __webpack_public_path__ + "static/media/vessel_image_default.13dc4e7aa73f6c5587a1477c04df12bb.svg";
export { ForwardRef as ReactComponent };